module.exports = __webpack_public_path__ + "static/media/mundo icon.fdff2e77.svg";